import { LoaderExternalFileService } from '@/services/loader-external-file';
import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

declare const DpeGes: any; // ideally type the function

export type DpeGesType = 'DPE' | 'GES';

export const DpeGesType = {
  DPE: 'DPE' as DpeGesType,
  GES: 'GES' as DpeGesType
};

@Component({
  selector: 'app-dpe-ges',
  templateUrl: './dpe-ges.component.html',
  styleUrls: ['./dpe-ges.component.scss'],
  standalone: true,
  imports: [NgIf]
})
export class DpeGesComponent implements OnInit {
  @Input() type: DpeGesType;
  @Input() value: number;

  width: number;
  height: number;
  loadedLib = false;
  constructor(private deviceService: DeviceDetectorService) {
    this.loadDpegesLib();
  }

  ngOnInit() {
    if (this.deviceService.isMobile()) {
      this.width = 240;
      this.height = 200;
    } else {
      this.width = 270;
      this.height = 225;
    }
  }

  isDpe(): boolean {
    return this.type === DpeGesType.DPE;
  }

  isGes(): boolean {
    return this.type === DpeGesType.GES;
  }

  showDpe() {
    if (this.value) {
      const dpeges = new DpeGes();
      dpeges.dpe({
        domId: 'dpe',
        width: this.width,
        height: this.height,
        value: this.value,
        shadow: false
      });
    }
  }

  showGes() {
    if (this.value) {
      const dpeges = new DpeGes();
      dpeges.ges({
        domId: 'ges',
        width: this.width,
        height: this.height,
        value: this.value,
        shadow: false
      });
    }
  }

  loadDpegesLib() {
    LoaderExternalFileService.loadDpeGesLib().then(() => {
      this.loadedLib = true;
    })
    .catch(err => {
      console.log(err);
      this.loadedLib = false;
    });
  }
}
